export const STRAGE_KEY_SONGS = 'selectedSongs'
export const STRAGE_KEY_QUERY = 'query'
export const API_URL = 'https://db9qp4rc97c3t.cloudfront.net/caoffVoteInfo'
